<script setup lang="ts">
  import type { Country } from '@storefront/types';
  import type { Dictionary } from '@othercommerce/domain';

  defineProps<{
    countries: Country[];
    readonly: boolean;
    regions: Dictionary;
  }>();
</script>

<template>
  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.COUNTRY')" name="countryCode" :options="countries" required :readonly />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.FIRSTNAME')" name="firstName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.LASTNAME')" name="lastName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.COMPANY_NAME')" name="company" required :readonly />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" name="email" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PHONE')" name="phone" />
  <SfAddressForm billable typed external-type="type" external-country="countryCode" :readonly :regions />
</template>
